import type { PropsWithChildren } from 'react'

import { Icon } from '@fv/client-components'

import { useHomePage } from '@/route-hooks'

import { HasFeature } from '../auth'

type Props = PropsWithChildren<{
  isLoading?: boolean
}>

export const TLBookingPageLayout = ({ children, isLoading }: Props) => {
  const homePage = useHomePage()

  return (
    <div className="shipper-page-fill shipper-grid-rows-single-fill grid grid-cols-[20rem_1fr] bg-[#f2f2f2]">
      <HasFeature name="truckLoad" redirect={homePage}>
        {isLoading ? (
          <div style={{ gridColumn: '1 / 3', margin: 'auto' }}>
            <Icon icon="spinner" size="2x" />
          </div>
        ) : (
          children
        )}
      </HasFeature>
    </div>
  )
}
